<template lang="pug">
#graficoAreaColhida
    div(v-show='possuiDadosHistoricos')
        apex-charts.component.apexcharts-canvas(
            type='bar',
            height='300',
            ref='chart',
            :options='options',
            :series='series'
        )

    div(v-show='!possuiDadosHistoricos')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            message='Ainda não foram obtidos dados históricos de cultivo para a cultura selecionada.'
        )
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import SelectCultura from '@/components/SelectCultura';
import EmptyResult from '@/components/EmptyResult';

import formatters from '@/utils/formatters';

export default {
    name: 'GraficoAreaColhida',
    components: {
        ApexCharts,
        SelectCultura,
        EmptyResult
    },

    props: {
        dadosHistorico: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            series: [],
            options: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '25%'
                    }
                },
                xaxis: {
                    categories: []
                },
                colors: [
                    'var(--soja-color)',
                    'var(--milho-color)',
                    '#b7a9ae',
                    '#DC610D'
                ],
                stroke: {
                    width: 2
                },
                yaxis: [
                    {
                        showAlways: true,
                        seriesName: 'Área colhida',
                        title: {
                            text: 'Área colhida (ha)'
                        },
                        labels: {
                            formatter: value => {
                                return value.toFixed(0);
                            }
                        },
                        min: 0,
                        max(max) {
                            return max + 20;
                        }
                    }
                ],
                tooltip: {
                    y: {
                        formatter: value => {
                            return formatters.formatNumber(value, 2) + ' ha';
                        }
                    }
                },
                dataLabels: {
                    style: {
                        colors: ['#333', '#333', '#333', '#333']
                    },
                    formatter: value => {
                        return formatters.formatNumber(value, 2);
                    },
                    enabled: true
                }
            }
        };
    },

    methods: {
        updateGrafico() {
            this.options.xaxis.categories = this.dadosHistorico.map(
                d => d.safra.descricao
            );

            let series = [];

            // let nomesCulturas = new Set(this.dadosHistorico.map(d => d.cultura.nome).sort().reverse());
            // Desculpa =(
            let nomesCulturas = ['Soja', 'Milho', 'Algodão', 'Outros'];
            nomesCulturas.forEach(nomeCultura => {
                let dadosPorCultura = this.dadosHistorico.map(d => {
                    const historicoCultura = d.historicosAgro.find(
                        h => h.cultura.nome === nomeCultura
                    );
                    if (historicoCultura) return historicoCultura.areaColhidaHa;
                    return 0.0;
                });
                series.push({
                    name: nomeCultura,
                    type: 'column',
                    data: dadosPorCultura
                });
            });

            this.series = series;

            this.$refs.chart.updateOptions(this.options, true);
        }
    },

    mounted() {
        this.updateGrafico();
    },

    watch: {
        dadosHistorico() {
            this.updateGrafico();
        }
    },

    computed: {
        possuiDadosHistoricos() {
            return this.dadosHistorico && this.dadosHistorico.length > 0;
        }
    }
};
</script>

<style scoped></style>
